if (!customElements.get('piecework-video-player')) {
  customElements.define(
    'piecework-video-player',
    class PieceworkMediaPlayer extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          video: this.querySelector('video'),
          controls: this.querySelector('button'),
          announcement: this.querySelector('[aria-live="polite"]'),
        };
        this.playing = false;
        // this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.video) return;

        this.elements.controls.addEventListener('click', this.togglePlaying.bind(this));
      }

      togglePlaying() {
        if (this.playing) {
          this.playing = false;
          this.elements.controls.classList.remove('playing');
          this.elements.video.pause();
          this.elements.announcement.textContent = 'Video is paused';
        } else {
          this.playing = true;
          this.elements.controls.classList.add('playing');
          this.elements.video.play();
          this.elements.announcement.textContent = 'Video is playing';
        }
      }

      // connectedCallback() {
      //   const handleIntersection = (entries, observer) => {
      //     if (!entries[0].isIntersecting) {
      //       this.playing = false;
      //       this.elements.controls.classList.remove('playing');
      //       this.elements.video.pause();
      //       this.elements.video.currentTime = 0;
      //       this.elements.announcement.textContent = 'Video is stopped';
      //     } else {
      //       this.playing = true;
      //       this.elements.controls.classList.add('playing');
      //       this.elements.video.play();
      //       this.elements.announcement.textContent = 'Video is playing from the beginning';
      //     }
      //   };
      //   if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      //     new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 0px 0px' }).observe(
      //       this.elements.video
      //     );
      //   }
      // }
    }
  );
}
